import createRequest from 'utils/request.ts';

export type ActionUrlTarget = '_blank' | '_self' | '_top';

export type Banner = {
  id: number;
  title: string;
  order_position: number;
  image_url: string;
  event_id: number | null;
  description?: string;
  action_url_target: ActionUrlTarget;
  action_url?: string;
  user_visibility: string;
};

export type BannerGroup = {
  id: number;
  layout: string;
  banners: Banner[];
};

type BannersRequestParams = {
  query: {
    lang: string;
    groupName: string;
    type: string;
  };
};

export const bannersRequest = createRequest<
  BannerGroup[],
  BannersRequestParams
>('/api/cms-go/v2/site/banner-group/list');
